<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <!-- Modal Dialog starts here -->
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content nlr-busy-modal">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="close()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <form
                id="fileUploadForm"
                name="fileUploadForm"
                novalidate
                autocomplete="off">
                <div class="modal-body">
                    <div class="container-fluid well">
                        <div class="row">
                            <div class="col-xs-12">
                                <div
                                    class="input-group"
                                    id="editArea"
                                    [ngClass]="{'has-error': !isSuffixValid}">
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-file"
                                            ng-click="attachmentsUploadModalController.clickFileInput()"></i>
                                    </span>
                                    <input
                                        ng-file-select=""
                                        id="fileToUpload"
                                        ng-model="fileToUpload"
                                        name="fileToUpload"
                                        #uploadFileInput
                                        (change)="uploadFileChange(uploadFileInput.files)"
                                        required=""
                                        class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched"
                                        [accept]="extensions"
                                        type="file" />

                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-paper-clip"
                                            (click)="uploadFileInput.click()"
                                            tabindex="0"></i>
                                    </span>
                                </div>
                                @if (!isSuffixValid) {
                                    <div class="help-block">
                                        <span>File with suffix of {{extensions | json}} must be selected.</span>
                                    </div>
                                }
                                @if (!isFileNameValid) {
                                    <div class="help-block">
                                        <span>File name should be unique. File name provided already exists.</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="modal-footer">
                <div class="form-group">
                    <button
                        id="uploadBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm upload"
                        (click)="validateAndUpload()">
                        Upload
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                    <input
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="close()"
                        value="Cancel"
                /></div>
            </div>
        </div>
    </div>
</div>
